import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";

export const ApologizeModal = ({ isApologizeModal, setIsApologizeModal }) => {
  const { t } = useTranslation();

  return (
    <Modal
      show={isApologizeModal}
      className="sorryto"
      onHide={(e) => window.location.replace("/")}
    >
      <Modal.Body>
        <div className="promocode_content cancelmembership ">
          <Link to="/" onClick={(e) => setIsApologizeModal(false)}>
            +
          </Link>
          <h2>
            <br/>
            {t("We are sorry to see you go!")}
          </h2>
          <img src="/images/return.png"/>
          <p style={{
            paddingBottom: "4rem",
            marginTop: "2rem",
          }}>
            {t("You can")} {" "}
              <Link color={"#A98D4B"} to={"/signup"} style={{
                color: "#A98D4B",
              }}>{t("come back")}</Link>
            {" "}
            {t("anytime.")}
          </p>
        </div>
      </Modal.Body>
    </Modal>
  );
};
